export default "__VITE_ASSET__DdDHl2dK__"